export default __webpack_public_path__ + "static/media/Pixel4.17fb01b7.gif";